import { render, staticRenderFns } from "./acquiringSchemaDetailsList.vue?vue&type=template&id=b0d96d4e"
import script from "./acquiringSchemaDetailsList.vue?vue&type=script&lang=js"
export * from "./acquiringSchemaDetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports